<div class="container-fluid"  *ngIf="costReviewMarginExceptions">
    <fieldset class="border rounded-3 p-1">
        <legend class="float-none w-auto px-1 ml-1 font-size-13">{{'REVIEW_SOL_MARGINS_TAB.TITLE'| translate}}</legend>
        <div class="row" [formGroup]="costReviewMarginsFormGroup" trackChanges>
            <div class="col-md-5">
                <div class="row bottomPadding" *ngIf="costReviewMarginExceptions.isEstimateClassificationApplicable">
                    <div class="col-sm-4">
                        <mat-label>{{'REVIEW_SOL_MARGINS_TAB.SYSTEM_TYPE' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-8">
                        <mat-radio-group class="radio-group" formControlName="systemType">
                            <si-radio-button [displayText]="'Siemens'" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"
                                [selectedValue]="costReviewMarginsFormGroup.controls['systemType'].value">
                            </si-radio-button>
                            <si-radio-button [displayText]="'Third Party'" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"
                                [selectedValue]="costReviewMarginsFormGroup.controls['systemType'].value">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding">
                    <div class="col-sm-4">
                        <mat-label>{{'REVIEW_SOL_MARGINS_TAB.ESTIMATED_MARGIN' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-1 mt-3">
                        <span>{{costReviewMarginExceptions.estimatedMargin | decimalPrecision}}%</span>
                    </div>
                    <div class="col-sm-3 mt-3 minimum-margin-container">
                        <span>[ {{'REVIEW_SOL_MARGINS_TAB.MINIMUM' | translate}} {{costReviewMarginExceptions.estimatedMarginMinimum | decimalPrecision}}% ]</span>
                    </div>
                    <div class="col-sm-2 mt-3">
                        <span>{{'REVIEW_SOL_MARGINS_TAB.VARIANCE' | translate}}</span>
                    </div>
                    <div class="col-sm-2 mt-3">
                        <span>{{variance | decimalPrecision}}%</span>
                    </div>
                </div> 
                <div class="row bottomPadding" *ngIf="costReviewMarginExceptions.isReasonForExceptionApplicable">
                    <div class="col-sm-4">
                        <mat-label>{{'REVIEW_SOL_MARGINS_TAB.SM_OR_BGM_APPROVAL_RECEIVED' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-8">
                        <mat-radio-group class="radio-group" formControlName="smBgmApproval">
                            <si-radio-button [displayText]="'YES' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"
                                [selectedValue]="costReviewMarginsFormGroup.controls['smBgmApproval'].value">
                            </si-radio-button>
                            <si-radio-button [displayText]="'NO' | translate" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"
                                [selectedValue]="costReviewMarginsFormGroup.controls['smBgmApproval'].value">
                            </si-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="row bottomPadding" *ngIf="costReviewMarginExceptions?.isReasonForExceptionApplicable">
                    <div class="col-sm-4">
                        <mat-label>{{'REVIEW_SOL_MARGINS_TAB.APPROVERS_EMAIL' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-8 p-0 px-1">
                        <app-si-form-field formControlName="approverEmailId" [inputValue]="costReviewMarginExceptions.approverEmailId" [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"></app-si-form-field>
                    </div>
                </div>
                
                <div class="row bottomPadding" *ngIf="costReviewMarginExceptions?.isReasonForExceptionApplicable">
                    <div class="col-sm-4">
                        <mat-label>{{'REVIEW_SOL_MARGINS_TAB.REASON_FOR_EXCEPTION' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-8 plr-9">
                        <si-combo-box formControlName="reasonForException"
                            [inputValue]="costReviewMarginExceptions.reasonForException"
                            [isReadMode]="isReadOnlyMode" [isDisabled]="isDisabled"
                            [dropDownList]="reasonForExceptionOptions">
                        </si-combo-box>
                    </div>
                </div>         
            </div>
        <div class="col-sm-1 space-between"></div>
            <div class="col-sm-5">
                <div class="row bottomPadding padding-left-10">
                    <div class="col-sm-4">
                        <mat-label>{{'REVIEW_SOL_MARGINS_TAB.PROJECT_DURATION' | translate}}</mat-label>
                    </div> 
                    <div class="col-sm-2 mt-3">
                        <span>{{'REVIEW_SOL_MARGINS_TAB.START_DATE' | translate}}</span>
                    </div>
                    <div class="col-sm-2 mt-3">
                        <span>{{costReviewSummary?.projectStartDate | date:('COMMON_LABELS.DATE_FORMAT' | translate)}}</span>
                    </div>
                    <div class="col-sm-2 mt-3">
                        <span>{{'REVIEW_SOL_MARGINS_TAB.END_DATE' | translate}}</span>
                    </div>
                    <div class="col-sm-2 mt-3">
                        <span>{{costReviewSummary?.projectEndDate | date:('COMMON_LABELS.DATE_FORMAT' | translate)}}</span>
                    </div>
                </div>
                <div class="row bottomPadding padding-left-10">
                    <div class="col-sm-4">
                        <mat-label>{{'REVIEW_SOL_MARGINS_TAB.ESCALATION_APPLIED' | translate}}</mat-label>
                    </div>
                    <div class="col-sm-2 mt-3">
                        <span>{{costReviewMarginExceptions.escalationApplied}}</span>
                    </div>
                    <div class="col-sm-2 mt-3">
                        <span>[ {{costReviewMarginExceptions.escalationCost | multilingualCurrency}} ]</span>
                    </div>
                    <div class="col-sm-2"></div>
                    <div class="col-sm-2"></div>
                </div>
               
            </div>
        </div>
</fieldset>
</div>
<div class="container-fluid customizeText" *ngIf="showSectionNotApplicableMsg && !costReviewMarginExceptions">
    {{'REVIEW_SOL_MARGINS_TAB.MARGINS_DATA_NOT_FOUND' | translate}}
</div>